// What the install dialog says while a large install is followed (keepr-api KPR-1655).

/** What the install dialog says while a run is followed: its step, in the platform's words. */
export function installProgressWords(run, { joined = false } = {}) {
	const step = {
		cards: 'Adding the cards',
		examples: 'Adding the examples',
		settings: 'Adding the saved filters, layouts, rules and charts',
	}[run?.step] || (run?.kind === 'add-ons' ? 'Adding the add-ons' : 'Adding the package');
	return joined ? `You are already adding this package. ${step}…` : `${step}…`;
}
